export enum IndustryType {
  CHURCH = 'church',
  NON_PROFIT = 'non-profit',
  OTHER = 'other',
}
